import { ConflictType, type Finding } from '@consigli/types';

import { type AddContextMenuKind, type AddContextSelection } from '../types';

export type FindingContextKind = Exclude<AddContextMenuKind, 'document'>;

/** Findings the add-context menu offers under a row of their own, not under Add Findings. */
const OWN_ROW_KINDS: Partial<Record<ConflictType, FindingContextKind>> = {
  [ConflictType.MILESTONE]: 'milestone',
  [ConflictType.DELIVERABLE]: 'response-requirement',
};

export const conflictTypeContextKind = (conflictType: ConflictType): FindingContextKind =>
  OWN_ROW_KINDS[conflictType] ?? 'finding';

/** Which add-context row a finding belongs to, and so which kind it attaches as. */
export const findingContextKind = (finding: Finding): FindingContextKind =>
  conflictTypeContextKind(finding.conflictType);

/** The one kind a selection carries, or null when nothing is attached. */
export const attachedContextKind = ({
  documents,
  findings,
}: AddContextSelection): AddContextMenuKind | null => {
  if (findings.length) return findingContextKind(findings[0]);
  return documents.length ? 'document' : null;
};
